export const downloadFile = function (url: string, fileName: string): void {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const splitFileExt = function (filePath: string): string[] {
  const [filePathWithoutExt, fileExt] = filePath.split(/\.(?=[^.]+$)/);
  return [filePathWithoutExt, fileExt ? fileExt.toLowerCase() : ''];
};
